// src/pages/ContractManagement.jsx
import React, { useState } from 'react';
import { FaTruck, FaMoneyBillWave, FaClipboardList } from 'react-icons/fa';
import { utils, writeFile } from 'xlsx';
import { Pie, Bar } from 'react-chartjs-2';
import 'chart.js/auto';

const ContractManagement = () => {
  const [contracts, setContracts] = useState([
    {
      name: 'Transportadora ABC',
      contractNumber: '12345',
      serviceType: 'Frete',
      startDate: '2023-01-01',
      endDate: '2023-12-31',
      pdfFile: null
    },
    {
      name: 'Transportadora XYZ',
      contractNumber: '67890',
      serviceType: 'Carga Seca',
      startDate: '2023-02-01',
      endDate: '2023-11-30',
      pdfFile: null
    },
    {
      name: 'Motorista João',
      contractNumber: '11223',
      serviceType: 'Carga Líquida',
      startDate: '2023-03-01',
      endDate: '2023-10-31',
      pdfFile: null
    }
  ]);
  const [newContract, setNewContract] = useState({
    name: '',
    contractNumber: '',
    serviceType: '',
    startDate: '',
    endDate: '',
    pdfFile: null
  });
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewContract({ ...newContract, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      setNewContract({ ...newContract, pdfFile: file });
      setErrors({ ...errors, pdfFile: '' });
    } else {
      setErrors({ ...errors, pdfFile: 'Por favor, selecione um arquivo PDF.' });
    }
  };

  const validateForm = () => {
    let formErrors = {};
    if (!newContract.name) formErrors.name = 'Nome é obrigatório';
    if (!newContract.contractNumber) formErrors.contractNumber = 'Número do contrato é obrigatório';
    if (!newContract.serviceType) formErrors.serviceType = 'Tipo de serviço é obrigatório';
    if (!newContract.startDate) formErrors.startDate = 'Data de início é obrigatória';
    if (!newContract.endDate) formErrors.endDate = 'Data de término é obrigatória';
    if (!newContract.pdfFile) formErrors.pdfFile = 'Arquivo PDF é obrigatório';
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleAddContract = () => {
    if (validateForm()) {
      setContracts([...contracts, newContract]);
      setNewContract({
        name: '',
        contractNumber: '',
        serviceType: '',
        startDate: '',
        endDate: '',
        pdfFile: null
      });
      setErrors({});
    }
  };

  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleDownloadExcel = () => {
    const contractsWithLinks = contracts.map(contract => ({
      ...contract,
      pdfFile: contract.pdfFile ? URL.createObjectURL(contract.pdfFile) : 'Nenhum arquivo'
    }));
    const worksheet = utils.json_to_sheet(contractsWithLinks);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Contracts");
    writeFile(workbook, "contracts.xlsx");
  };

  const paymentData = {
    labels: ['Custo por kg/entrega', 'Ticket médio por entrega'],
    datasets: [
      {
        label: 'Sugestão de Forma de Pagamento do Frete',
        data: [1.50, 200.00],
        backgroundColor: ['#FF6384', '#36A2EB'],
        hoverBackgroundColor: ['#FF6384', '#36A2EB']
      }
    ]
  };

  const vehicleData = {
    labels: ['Total de veículos cadastrados', 'Veículos em operação'],
    datasets: [
      {
        label: 'Controle de Veículos',
        data: [10, 8],
        backgroundColor: ['#FFCE56', '#FF6384'],
        hoverBackgroundColor: ['#FFCE56', '#FF6384']
      }
    ]
  };

  const paymentControlData = {
    labels: ['Pagamentos realizados', 'Saldo devedor'],
    datasets: [
      {
        label: 'Controle e Gestão de Pagamentos',
        data: [50000, 10000],
        backgroundColor: ['#36A2EB', '#FFCE56'],
        hoverBackgroundColor: ['#36A2EB', '#FFCE56']
      }
    ]
  };

  return (
    <div className="flex w-full justify-center items-center max-h-screen bg-white-less">
      <div className="w-full p-8 h-screen bg-white-less rounded-lg shadow-lg overflow-y-scroll">
        <h1 className="text-4xl font-bold mb-8 text-center text-gray-800">Gestão de Contratos</h1>
        
        <div className="grid grid-cols-3 gap-8 h-fit">
          <div className="bg-white-whiter p-8 rounded-lg shadow-md overflow-y-auto h-full">
            <h2 className="text-2xl font-semibold mb-6 text-gray-700 flex items-center"><FaTruck className="mr-2" /> Cadastro de Caminhões Terceirizados</h2>
            <div className="grid grid-cols-1 gap-6">
              <div>
                <input
                  type="text"
                  name="name"
                  value={newContract.name}
                  onChange={handleInputChange}
                  placeholder="Nome ou Razão Social*"
                  className={`p-4 border rounded-md w-full focus:outline-none focus:border-salBlue ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
              </div>
              <div>
                <input
                  type="text"
                  name="contractNumber"
                  value={newContract.contractNumber}
                  onChange={handleInputChange}
                  placeholder="Número do Contrato*"
                  className={`p-4 border rounded-md w-full focus:outline-none focus:border-salBlue ${errors.contractNumber ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.contractNumber && <p className="text-red-500 text-sm mt-1">{errors.contractNumber}</p>}
              </div>
              <div>
                <input
                  type="text"
                  name="serviceType"
                  value={newContract.serviceType}
                  onChange={handleInputChange}
                  placeholder="Tipo de Serviço*"
                  className={`p-4 border rounded-md w-full focus:outline-none focus:border-salBlue ${errors.serviceType ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.serviceType && <p className="text-red-500 text-sm mt-1">{errors.serviceType}</p>}
              </div>
              <div>
                <input
                  type="date"
                  name="startDate"
                  value={newContract.startDate}
                  onChange={handleInputChange}
                  placeholder="Data de Início*"
                  className={`p-4 border rounded-md w-full focus:outline-none focus:border-salBlue ${errors.startDate ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.startDate && <p className="text-red-500 text-sm mt-1">{errors.startDate}</p>}
              </div>
              <div>
                <input
                  type="date"
                  name="endDate"
                  value={newContract.endDate}
                  onChange={handleInputChange}
                  placeholder="Data de Término*"
                  className={`p-4 border rounded-md w-full focus:outline-none focus:border-salBlue ${errors.endDate ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.endDate && <p className="text-red-500 text-sm mt-1">{errors.endDate}</p>}
              </div>
              <div>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={handleFileChange}
                  className="p-4 border rounded-md w-full"
                />
                {errors.pdfFile && <p className="text-red-500 text-sm mt-1">{errors.pdfFile}</p>}
              </div>
            </div>
            <div className='flex justify-center gap-16 mt-8'>
              <button
                onClick={handleAddContract}
                className="bg-salBlue text-white-whiter p-2 rounded-md w-1/3 hover:bg-blue-700 transition duration-200"
              >
                Cadastrar
              </button>
              <button
                onClick={handleOpenPopup}
                className="bg-salBlue text-white-whiter p-4 rounded-md w-1/3 hover:bg-blue-700 transition duration-200"
              >
                Relatório
              </button>
            </div>
          </div>
          <div className="grid grid-rows-2 gap-8">
            <div className="p-8 rounded-lg shadow-md  bg-white-whiter">
              <h2 className="text-2xl font-semibold mb-6 text-gray-700 flex items-center"><FaMoneyBillWave className="mr-2" /> Sugestão de Forma de Pagamento do Frete</h2>
              <div className="h-48 flex items-center w-full justify-center">
                <Pie data={paymentData} />
              </div>
            </div>
            <div className="p-8 rounded-lg shadow-md  bg-white-whiter">
              <h2 className="text-2xl font-semibold mb-6 text-gray-700 flex items-center"><FaTruck className="mr-2" /> Controle de Veículos</h2>
              <div className="h-48">
                <Bar data={vehicleData} />
              </div>
            </div>
          </div>
          <div className="grid grid-rows-2 gap-8">
            <div className="p-8 rounded-lg shadow-md  bg-white-whiter">
              <h2 className="text-2xl font-semibold mb-6 text-gray-700 bg-white-whiter flex items-center"><FaMoneyBillWave className="mr-2" /> Controle e Gestão de Pagamentos</h2>
              <div className="h-48">
                <Bar data={paymentControlData} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-black/50 flex items-center justify-center z-30">
          <div className="bg-white-whiter p-6 rounded-lg shadow-lg text-center w-3/4 max-w-4xl">
            <h2 className="text-2xl font-bold mb-4">Relatório de Contratos e Pagamentos</h2>
            <table className="min-w-full bg-white-whiter">
              <thead>
                <tr>
                  <th className="py-3 px-6 border-b">Nome</th>
                  <th className="py-3 px-6 border-b">Número do Contrato</th>
                  <th className="py-3 px-6 border-b">Tipo de Serviço</th>
                  <th className="py-3 px-6 border-b">Data de Início</th>
                  <th className="py-3 px-6 border-b">Data de Término</th>
                  <th className="py-3 px-6 border-b">Arquivo PDF</th>
                </tr>
              </thead>
              <tbody>
                {contracts.map((contract, index) => (
                  <tr key={index} className="hover:bg-gray-100 transition duration-200">
                    <td className="border px-6 py-3">{contract.name}</td>
                    <td className="border px-6 py-3">{contract.contractNumber}</td>
                    <td className="border px-6 py-3">{contract.serviceType}</td>
                    <td className="border px-6 py-3">{contract.startDate}</td>
                    <td className="border px-6 py-3">{contract.endDate}</td>
                    <td className="border px-6 py-3">
                      {contract.pdfFile ? (
                        <a href={URL.createObjectURL(contract.pdfFile)} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                          Ver PDF
                        </a>
                      ) : (
                        'Nenhum arquivo'
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="flex justify-center gap-4 mt-4">
              <button
                onClick={handleDownloadExcel}
                className="bg-gray-800 text-white-whiter font-bold text-xl py-2 px-8 rounded-lg shadow-lg hover:bg-salBlue transition-all hover:text-text"
              >
                Baixar Tabela
              </button>
              <button
                onClick={handleClosePopup}
                className="bg-gray-800 text-white-whiter font-bold text-xl py-2 px-8 rounded-lg shadow-lg hover:bg-salBlue transition-all hover:text-text"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContractManagement;